export default __webpack_public_path__ + "static/media/crown.93364ea0.svg";